import { render, staticRenderFns } from "./AssignConfirmationModal.vue?vue&type=template&id=32eb91c4&scoped=true"
import script from "./AssignConfirmationModal.vue?vue&type=script&lang=js"
export * from "./AssignConfirmationModal.vue?vue&type=script&lang=js"
import style0 from "./AssignConfirmationModal.vue?vue&type=style&index=0&id=32eb91c4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32eb91c4",
  null
  
)

export default component.exports